<template>
  <a-statistic
    :class="[bem.b()]"
    v-bind="attrs"
    :group-separator="props.showKilobit ? props.groupSeparator : ''"
  >
    <template v-for="item in Object.keys($slots)" :key="item" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-statistic>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'

import { createNamespace } from '@ll-plus/utils'
import { statisticProps } from './statistic'

defineOptions({ name: 'LlStatistic' })

const props = defineProps(statisticProps)
const bem = createNamespace('statistic')

const attrs = useAttrs()
</script>
